import React, { useRef, useMemo, useCallback, useState } from 'react';
import { useSelector } from 'react-redux';
import { toast } from 'react-toastify';

import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import Checkbox from '@material-ui/core/Checkbox';


import { setHours, setMinutes, setSeconds, format, subDays } from 'date-fns';
import * as Yup from 'yup';
import {
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from '@material-ui/core';
import { Send } from '@material-ui/icons';
import { includes, isArray, isEmpty, isUndefined } from 'lodash';
import axios from 'axios';

import { DateTime, Autocomplete, Select, RadioGroup } from '~/components/Form';

import { t, parseDateString } from '~/helpers';
import api from '~/services/api';

import * as S from './styles';

export default function DlgRelResumoTurno() {
  const [loading, setLoading] = useState(false);
  const [open, setOpen] = useState(true);

  const [intervalo, setIntervalo] = useState({}); // Intervalo do relatório
  const [posto, setPosto] = useState([]); // Posto
  const [datasTurnos, setDatasTurnos] = useState([]); // Data inicial do turno
  const [turnosCompletos, setTurnosCompletos] = useState([]); // Todos os turnos
  const [turnos, setTurnos] = useState([]); // Turno

  const [datasValue, setDatasValue] = useState('');
  const [turnosValue, setTurnosValue] = useState('');

  const formRef = useRef(null);

  const [type, setType] = useState('ambiente');

  const [rowsTurnos, setRowsTurnos] = React.useState([
    // { turn_cod_turn: 19507, turn_datahora_ini: '01/01/2021 07:26:05', turn_num_turn: 1 },
    // { turn_cod_turn: 19508, turn_datahora_ini: '01/01/2021 20:37:32', turn_num_turn: 2 },
  ]);

  const [postoTela, setPostoTela] = useState({ post_cod_posto: '', post_desc: '' });

  const [selected, setSelected] = React.useState([]);


  const { glousuariotipo, glousuariologin } = useSelector(
    (state) => state.user.profile
  );
  const { token } = useSelector((state) => state.auth);

  const optionsTypeReport = useMemo(
    () => [
      { label: 'Manifestado', value: 'manifestado' },
      { label: 'Ambiente', value: 'ambiente' },
      { label: '20º', value: '20' },
    ],
    []
  );


  const datahorainicial = useMemo(
    () =>
      format(
        setSeconds(setMinutes(setHours(subDays(new Date(), 7), 0), 0), 0),
        'dd/MM/yyyy HH:mm:ss'
      ),
    []
  );

  const datahorafinal = useMemo(
    () =>
      format(
        setSeconds(setMinutes(setHours(new Date(), 23), 59), 59),
        'dd/MM/yyyy HH:mm:ss'
      ),
    []
  );

  const validation = useMemo(
    () => ({
      post_cod_posto: Yup.string()
        .required(t('s.geral.validacao.campoobrigatorio'))
        .nullable(),
      datahorainicial: Yup.string()
        .required(t('s.geral.validacao.campoobrigatorio'))
        .nullable(),
    }),
    []
  );

  const validationSubmit = useMemo(
    () => ({
      post_cod_posto: Yup.string()
        .required(t('s.geral.validacao.campoobrigatorio'))
        .nullable(),
      datahorainicial: Yup.string()
        .required(t('s.geral.validacao.campoobrigatorio'))
        .nullable(),
    }),
    []
  );


  const initials = useMemo(
    () => ({
      posto,
      datahorainicial,
      datahorafinal,
      datasTurnos,
      turnos,
      tiporel: 'ambiente',
      formato: 'pdf',
    }),
    [posto, datahorainicial, datahorafinal, datasTurnos, turnos]
  );

  function findTurnoPeloId(id) {
    return rowsTurnos.find((element) => {
      return element.turn_cod_turn === id;
    });
  }

  const handleSubmit = useCallback(
    async (data) => {
      try {
        setLoading(true);

        const schema = Yup.object().shape(validationSubmit);

        await schema.validate(data, {
          abortEarly: false,
        });

        let turno = selected[0];

        if (isUndefined(turno)) {
          toast.error("Selecione um turno antes!");
        }

        const { datahorainicial, datahorafinal, formato, } = data;
        const { REACT_APP_URL_DOWNLOAD } = process.env;



        let poco_descricao = posto.post_desc;
        let unidadestr = posto.post_desc;
        let turnoSelecionado = findTurnoPeloId(turno);

        // compoe chamada com dados do turno selecionado
        let numeroturno = turnoSelecionado.turn_num_turn;
        let turnoinicio = turnoSelecionado.turn_datahora_ini;
        let turnofim = turnoSelecionado.turn_datahora_fim;
        let turnocodigo = turnoSelecionado.turn_cod_turn;
        let operador = turnoSelecionado.oper_cod_oper;
        let operadornome = turnoSelecionado.oper_nome;

        let tipo = 'pdf';

        if (formato) {
          tipo = formato;
        }

        let tiporel = type;



        const url = new URL(REACT_APP_URL_DOWNLOAD);

        url.search = new URLSearchParams({
          idtarefapath: "dlgRelResumoTurno.swf",

          relatorio: 'RESUMOTURNO',
          token,
          datainicial: turnoinicio,
          datafinal: turnofim,
          codturno: turnocodigo,
          strposto: poco_descricao,
          posto: posto.post_cod_posto,
          unidadestr,
          numturno: numeroturno,
          turnoinicio,
          turnofim,
          tiporel,
          operador: operador,
          stroperador: operadornome,
          strusuario: posto.usua_nome,

          tipo,
        });

        const response = await axios({
          url: url.href,
          method: 'GET',
          responseType: 'blob',
        });

        const file = new Blob([response.data], { type: response.data.type });

        if (window.navigator && window.navigator.msSaveOrOpenBlob) {
          window.navigator.msSaveOrOpenBlob(file);
        } else {
          const objectUrl = URL.createObjectURL(file);
          window.open(objectUrl);
        }
      } catch (err) {
        const validationErrors = {};

        toast.error(t(err));

        if (err instanceof Yup.ValidationError) {
          err.inner.forEach((error) => {
            validationErrors[error.path] = error.message;
          });

          formRef.current.setErrors(validationErrors);
        } else {
          if (isArray(err)) err.map((e) => toast.error(t(e)));
          else toast.error(t(err));
        }
      } finally {
        setLoading(false);
      }
    },
    [turnosCompletos, selected, type]
  );

  const handleFiltrar = useCallback(async () => {
    try {
      setLoading(true);

      // limpa lista
      setDatasTurnos([]);
      setTurnos([]);

      // limpa campos
      setDatasValue('');
      setTurnosValue('');
      formRef.current.setFieldValue('data', '');
      formRef.current.setFieldValue('turno', '');

      const formData = formRef.current.getData();
      const schema = Yup.object().shape(validation);

      await schema.validate(formData, {
        abortEarly: false,
      });

      const response = await api.get(
        `turno/getturnosinicio?codigoposto=${formData.post_cod_posto}&datahorainicio=${formData.datahorainicial}`
      );

      let optDatasTurnos = [];

      if (!isEmpty(response.data)) {
        response.data.map((value) => {
          optDatasTurnos.push({
            turn_cod_turn: value.turn_cod_turn,
            turn_datahora_ini: value.turn_datahora_ini,
            turn_datahora_fim: value.turn_datahora_fim,
            turn_num_turn: value.turn_num_turn,
            oper_cod_oper: value.oper_cod_oper,
            oper_nome: value.oper_nome
          });
        });
      } else {
        toast.error('Não existe turno na data selecionada!');
      }


      setDatasTurnos(optDatasTurnos);
      setRowsTurnos(optDatasTurnos);
    } catch (err) {
      setDatasTurnos([]);
      setRowsTurnos([]);

      const validationErrors = {};

      if (err instanceof Yup.ValidationError) {
        err.inner.forEach((error) => {
          validationErrors[error.path] = error.message;
        });

        formRef.current.setErrors(validationErrors);
      } else {
        if (isArray(err)) err.map((e) => toast.error(t(e)));
        else toast.error(t(err));
      }
    } finally {
      setLoading(false);
    }
  }, [validation]);

  async function handleDatasTurnos(dataTurno) {
    let optturnos = [];
    const formData = formRef.current.getData();

    formRef.current.setFieldValue('turno', '');

    const response = await api.get(
      `turnos/retornaturno?unidade=${formData.poco_codigo}&dataInicio=${dataTurno} 00:00:00&dataFim=${dataTurno} 23:59:59`
    );

    if (!isEmpty(response.data)) {
      setTurnosCompletos(response.data);

      response.data.map((value) => {
        optturnos.push({
          value: value.turnCodigo,
          label:
            'Turno ' +
            value.turnNumero +
            ' - ' +
            value.turnDataHoraInicioStr.substring(11, 19),
        });
      });
    }

    setTurnos(optturnos);
  }

  const handleClearDatasTurnosAndTurnos = useCallback(() => {
    setDatasTurnos([]);
    setDatasValue('');
    setTurnos([]);
    setTurnosValue('');
    setRowsTurnos([]);
    setSelected([]);
    formRef.current.setFieldValue('data', '');
    formRef.current.setFieldValue('turno', '');
  }, []);

  const handleLookForDifference = useCallback(
    (field, value) => {
      if (intervalo[field] !== value) handleClearDatasTurnosAndTurnos();
    },
    [intervalo]
  );

  const isSelected = (name) => selected.indexOf(name) !== -1;

  const handleClick = (event, name) => {
    const selectedIndex = selected.indexOf(name);
    let newSelected = [name];

    //if (selectedIndex === -1) {
    //      newSelected = newSelected.concat(selected, name);
    // }
    //  else if (selectedIndex === 0) {
    //   newSelected = newSelected.concat(selected.slice(1));
    // } else if (selectedIndex === selected.length - 1) {
    //   newSelected = newSelected.concat(selected.slice(0, -1));
    // } else if (selectedIndex > 0) {
    //    newSelected = newSelected.concat(
    //      selected.slice(0, selectedIndex),
    //      selected.slice(selectedIndex + 1)
    //    );
    // }
    setSelected(newSelected);
  };

  return (
    <Dialog
      disableBackdropClick
      disableEscapeKeyDown
      fullWidth
      open={open}
      onClise={() => setOpen(false)}
      maxWidth="sm"
    >
      <DialogTitle>Resumo de Turno</DialogTitle>
      <DialogContent>
        <S.Wrapper ref={formRef} onSubmit={handleSubmit} initialData={initials}>

          <RadioGroup
            row
            name="tiporel"
            label="Tipo"
            options={optionsTypeReport}
            getValue={(value) => {
              setType(value);
              setPostoTela({ post_cod_posto: '', post_desc: '' });
              formRef.current.setFieldValue('post_cod_posto', '');
              handleClearDatasTurnosAndTurnos();
            }}
          />

          <Autocomplete
            includeInputInList
            disabledItemsFocusable

            name="post_cod_posto"
            label="post_desc"
            title="Posto"
            url="usuarioposto"
            unique="post_cod_posto"
            params={[{ orderfield: 'post_cod_posto' }]}
            getValue={(value) => {
              setPosto(value);
              setDatasValue('');
              setTurnosValue('');
              formRef.current.setFieldValue('data', '');
              formRef.current.setFieldValue('turno', '');
            }}
            //onInputChange={handleClearDatasTurnosAndTurnos}
            onInputChange={(event, value) => {
              handleClearDatasTurnosAndTurnos();
              let obj = {
                ...postoTela,
                post_desc: value,
              }
              setPostoTela(obj);
            }}

            params={{
              wherefield: 'post_controla_20',
              valuewherefield: type === '20' ? 'N' : 'T',
              typewherefield: 'NEQUALS',
            }}

            inputValue={postoTela.post_desc}




          />

          <DateTime
            time
            label="Data"
            name="datahorainicial"
            onBlur={(value) =>
              handleLookForDifference('start', value.target.value)
            }
            onAccept={handleClearDatasTurnosAndTurnos}
            getValue={(value) => {
              setIntervalo((state) => ({ ...state, start: value }));
            }}
            disableFuture
          />

          {/* <DateTime
            time
            label="Data Final"
            name="datahorafinal"
            onBlur={(value) =>
              handleLookForDifference('end', value.target.value)
            }
            onAccept={handleClearDatasTurnosAndTurnos}
            getValue={(value) => {
              setIntervalo((state) => ({ ...state, end: value }));
            }}

            disableFuture
          /> */}

          <Button
            type="button"
            startIcon={<Send />}
            color="default"
            variant="outlined"
            onClick={handleFiltrar}
          >
            FILTRAR
          </Button>


          <div className="Container__nf_dados_grade">
            <TableContainer component={Paper}>
              <Table
                style={{ minWidth: 380, zIndex: -1 }}
                size="small"
                aria-label="simple table"
              >
                <TableHead>
                  <TableRow>
                    <TableCell align="right"></TableCell>
                    {/* <TableCell align="right">Turno</TableCell> */}
                    <TableCell align="right">Número</TableCell>
                    <TableCell align="right">Data</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>

                  {rowsTurnos.map((row, index) => {
                    const isItemSelected = isSelected(row.turn_cod_turn);
                    const labelId = `enhanced-table-checkbox-${index}`;
                    return (
                      <TableRow
                        hover
                        key={row.turn_cod_turn}
                        onClick={(event) => handleClick(event, row.turn_cod_turn)}
                        selected={isItemSelected}
                        role="checkbox"
                        aria-checked={isItemSelected}
                        tabIndex={-1}
                      >
                        <TableCell padding="checkbox">
                          <Checkbox
                            checked={isItemSelected}
                            inputProps={{ 'aria-labelledby': labelId }}
                          />
                        </TableCell>
                        {/* <TableCell align="right">{row.turn_cod_turn}</TableCell> */}
                        <TableCell align="right">{row.turn_num_turn}</TableCell>
                        <TableCell align="right">{row.turn_datahora_ini}</TableCell>
                      </TableRow>
                    );
                  })}
                </TableBody>
              </Table>
            </TableContainer>
          </div>


          <RadioGroup
            row
            name="formato"
            label="Formato"
            options={[
              { label: 'PDF', value: 'pdf' },
              { label: 'Excel', value: 'xls' },
            ]}
            defaultValue="pdf"
            serialize={(value) => value}
          />
        </S.Wrapper>
      </DialogContent>
      <DialogActions>
        <Button
          color="primary"
          variant="outlined"
          onClick={() => formRef.current.submitForm()}
          disabled={loading}
        >
          Exibir
        </Button>

        <Button
          color="secondary"
          variant="outlined"
          onClick={() => setOpen(false)}
        >
          Cancelar
        </Button>
      </DialogActions>
    </Dialog>
  );
}
